<template>
  <div class="direct-message-edit">
    <el-button class="mb-x2" type="default" @click="back"><i class="mdi mdi-keyboard-backspace"></i>戻る</el-button>
    <div class="input-container">
      <div class="label">種別</div>
      <el-select
        v-model="type"
        @change="onChangeType('種別')"
        :disabled="isDisabledInput"
        placeholder="選択してください"
      >
        <el-option v-for="(type, index) in types" :value="type.value" :label="type.label" :key="index"></el-option>
      </el-select>
      <div class="description" v-if="typeText">宛先: {{ typeText }}</div>
      <div class="mt-x1 mb-x2" v-if="!isSendCountLoading && isTypeSelected">
        <div class="description mt-0">配信対象数: {{ sendCount }}</div>
        <div class="description mt-0" v-if="isLimitSendCount">残り配信可能数: {{ remainMonthlyDmCount }}</div>
        <div class="text-danger" v-if="isRemainEmpty">残り配信可能数がありません。</div>
        <div class="text-danger" v-else-if="isSendCountEmpty">配信対象となる当選者が存在しません。</div>
        <div class="text-danger" v-else-if="isSendCountOver">
          配信対象数が残り配信可能数を超えています。<br />月間最大DM・メンション配信件数を変更してください。 （<a
            href="https://help-atelu.comnico.jp/set-usage-limit"
            target="_blank"
            >ヘルプ: 利用制限設定</a
          >）
        </div>
      </div>
    </div>
    <!-- 配信方法-->
    <div class="input-container">
      <div class="label">
        配信方法
        <el-tooltip class="ml-x1" placement="top">
          <div slot="content">メッセージの配信方法を選択してください。</div>
          <i class="mdi mdi-help-circle"></i>
        </el-tooltip>
      </div>
      <div class="input">
        <el-radio border label="DM" v-model="sendType" tabindex="15" @change="onChangeType" :disabled="isDisabledInput"
          >DM</el-radio
        >
      </div>
    </div>
    <div class="input-container">
      <div class="label">テンプレート</div>
      <div class="template-manage">
        <el-select
          class="mr-x2"
          v-model="template"
          @change="onChangeTemplate"
          :disabled="isDisabledInput"
          placeholder="テンプレートを呼び出す場合、選択してください"
        >
          <el-option
            v-for="(messageTemplate, index) in messageTemplates"
            :value="messageTemplate.id"
            :label="messageTemplate.name"
            :key="index"
          ></el-option> </el-select
        ><a href="/settings/group#templates" target="_blank" @click="clickLink"
          ><i class="mdi mdi-open-in-new mr-x1"></i>テンプレート管理</a
        >
      </div>
    </div>
    <div class="input-container">
      <div class="label">
        {{ 'メッセージ内容' | translate }}
        <el-tooltip class="ml-x1" placement="top">
          <div slot="content">
            URLは自動的に「t.co」形式へ変換されます。<br />
            また、文末をURLで終わらせるとメッセージが省略されるため、必ず末尾はテキストで締めてください。<br />
            詳細は
            <a href="https://help-atelu.comnico.jp/20260120-information" target="_blank" rel="noopener noreferrer"
              >コチラ</a
            >
            をご確認ください
          </div>
          <i class="mdi mdi-help-circle"></i>
        </el-tooltip>
        <div class="sub">{{ bodyLength | number }} / {{ 4000 | number }}</div>
      </div>
      <editable
        class="body-textarea"
        v-model="body"
        :highlights="highlights"
        :placeholder="'内容入力'"
        :class="{ success: $v.body.required && !$v.body.$invalid && body.trim() }"
        :disabled="isDisabledInput"
        @input="onChangeMessage"
      ></editable>
      <div class="mt-x1" v-if="!serialCode.total && hasSerialCodeInMessageBody">
        <Message type="danger"
          >シリアルコードが未登録のため、このままではメッセージを配信できません。<br />配信開始までに
          [シリアルコードの管理] から追加してください。</Message
        >
      </div>
      <div class="mt-x1" v-if="serialCode.total > 0 && !hasSerialCodeInMessageBody">
        <Message type="warning"
          >登録されているシリアルコードがあります。<br />配信する場合は、変数(_serial_code_)をメッセージ内容に入力してください。</Message
        >
      </div>
    </div>
    <!-- メディア情報-->
    <div
      class="input-container mb-x4"
      v-loading="isLoadMedia"
      element-loading-text="画像・動画をアップロードしています。 しばらくお待ちください。"
    >
      <div v-if="!isDisabledInput">
        <label class="el-button el-button--default"
          ><i class="mdi mdi-image"></i><span v-if="!media">画像/動画を追加</span
          ><span v-if="media">画像/動画を変更</span>
          <input
            type="file"
            style="display: none"
            @change="handleFileChange($event)"
            accept="video/mp4,image/jpeg,image/png,image/pjpeg,image/gif"
            ref="mediaInput"
          /> </label
        ><span class="pl-x2">アップロード可能最大サイズ: 画像5MB 動画25MB</span>
      </div>
      <div class="mt-x2 media-preview" v-if="media">
        <i class="mdi mdi-close" v-if="!isDisabledInput" @click="removeMedia"></i>
        <div class="media-name">{{ media.mediaOriginName }}</div>
        <img class="direct-media mt-x1" v-if="media && isImage" :src="media.mediaUrl" />
        <video class="direct-media mt-x2" v-if="media && !isImage" :src="media.mediaUrl" controls="true"></video>
      </div>
    </div>
    <div class="input-container">
      <MessageConvert
        :is-web-iw-remind-dm="campaign.type === 'old_web_instantwin' && type"
        :is-web-iw-win-dm="campaign.type === 'old_web_instantwin' && !type"
        :is-campaign-remind-dm="campaign.type === 'keyword' && type"
      ></MessageConvert>
    </div>
    <div class="input-container">
      <div class="label">メッセージ配信開始日</div>
      <el-date-picker
        v-model="startDate"
        ref="startDate"
        type="date"
        value-format="yyyy-MM-dd"
        prefix-icon="mdi mdi-calendar-today"
        placeholder="開始日"
        :picker-options="startDateOption"
        :editable="false"
        :disabled="isDisabledInput"
        @change="onChangeStartDate"
      ></el-date-picker>
      <div class="input-invalid-text" v-if="isDateInput">開始日を入力してください。</div>
    </div>
    <div class="input-container">
      <div class="label">メッセージ配信時間</div>
      <el-time-select
        class="mr-x2"
        v-model="startTime"
        ref="startTime"
        prefix-icon="mdi mdi-clock"
        placeholder="開始時間"
        :picker-options="startTimeOption"
        :editable="false"
        :disabled="isDisabledInput"
        @change="onChangeStartTime"
      ></el-time-select
      >~
      <el-time-select
        class="ml-x2 mr-x2"
        v-model="endTime"
        ref="startTime"
        prefix-icon="mdi mdi-clock"
        placeholder="終了時間"
        :picker-options="endTimeOption"
        :editable="false"
        :disabled="isDisabledInput"
        @change="onChangeEndTime"
      ></el-time-select
      >までの間、配信する
      <div class="input-invalid-text" v-if="isStartTimeInput">開始時間を入力してください。</div>
      <div class="input-invalid-text" v-if="isEndTimeInput">終了時間を入力してください。</div>
      <div class="input-invalid-text" v-else-if="isTimeOver">開始時間は、終了時間より前に設定してください。</div>
      <div class="input-invalid-text" v-else-if="isDatetimeOver">
        開始日時は、現時刻より5分を超えるよう指定してください。
      </div>
      <div class="description">終了時間までに配信完了しなかった場合、翌日の開始時間に配信を再開します。</div>
    </div>
    <div class="input-container">
      <div class="label">
        1日の最大配信数(0=制限なし)
        <el-tooltip class="ml-x1" placement="top">
          <template v-slot:content>
            <span
              v-html="
                'X公式APIで送信できるDMは、1アカウントにつき24時間で最大100件です。<br>この配信のみで100件を使い切りたくない場合は、1日の最大配信数を設定してください。<br>配信対象者数が1日の最大配信数より多い場合、上限到達後に配信を翌日に繰り越します。<br>配信再開は、翌日のメッセージ配信時間です。'
              "
            ></span>
          </template>
          <template v-slot:default><i class="mdi mdi-help-circle ml-x1"></i></template>
        </el-tooltip>
      </div>
      <el-input-number
        controls-position="right"
        :min="0"
        v-model="sendLimitPerDay"
        :max="maxSendLimitPerDay"
        size="small"
      ></el-input-number>

      <div v-if="isExistQueue" class="message message-warning mt-x1 pl-x2 pr-x2">
        同一のXアカウントで1日に複数のメッセージ配信が予約されており、配信時間が重複する可能性があります。
        <br />
        配信上限を超えると配信が停止するため、超えそうな場合は配信数やメッセージ配信時間を調整してください。
        <br />
        詳しくは<a
          href="https://help-atelu.comnico.jp/0f4d7649-12aa-435a-abb6-868c2027000e#0f4d7649-12aa-435a-abb6-868c2027000e"
          target="_blank"
          rel="noopener noreferrer"
          >こちら</a
        >をご確認ください。
      </div>
      <div v-else-if="isUnlimitedOrLimit100" class="message message-warning mt-x1 pl-x2 pr-x2">
        1日のDM配信上限（1日100件）に設定されています。配信対象者が100件を超える場合、翌日のメッセージ配信時間に配信が再開されます。
        <br />
        また、この設定の配信期間中は「リマインド」や「シリアルコード未使用のリマインド」を含む追加のDM配信はできません。
      </div>
      <div v-else-if="isLimitOneHourToTwoHoursMessage" class="message message-warning mt-x1 pl-x2 pr-x2">
        {{ limitOneHourToTwoHoursMessage }}
        <br />
        DM配信上限（24時間で100件）に設定したい場合メッセージ配信時間を2時間半以上に設定してください。
      </div>
    </div>

    <div class="dialog-footer" v-if="isEdit">
      <el-button type="default" :disabled="disabledSubmit || isDisabledInput" @click="saveDraft"
        ><i class="mdi mdi-content-save"></i>下書き保存</el-button
      >
      <el-button
        type="primary"
        :disabled="disabledSubmit || isDisabledInput || isRemainEmpty || isSendCountEmpty || isSendCountOver"
        @click="saveScheduled"
        ><i class="mdi mdi-content-save"></i>一括配信スケジュールを更新</el-button
      >
    </div>
    <div class="dialog-footer" v-else>
      <el-button type="default" :disabled="disabledSubmit || isDisabledInput" @click="createDraft"
        ><i class="mdi mdi-content-save"></i>下書き保存</el-button
      >
      <el-button
        type="primary"
        :disabled="disabledSubmit || isDisabledInput || isRemainEmpty || isSendCountEmpty || isSendCountOver"
        @click="createScheduled"
        ><i class="mdi mdi-email"></i>一括配信スケジュールを新規作成</el-button
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'sass:math';
@use '@/client/assets/scss/variables.scss' as *;

.input-container {
  margin: 0 0 ($spacing-unit * 2);

  .el-select {
    width: $spacing-unit * 35;
  }
}

.description {
  margin-top: $spacing-unit;
  color: $sub-text-color;
}

.label {
  position: relative;
  margin: 0 0 $spacing-unit;
  font-size: $font-size;
  font-weight: 700;

  .sub {
    position: absolute;
    top: 0;
    right: 0;
    color: $sub-text-color;
  }
}

.template-manage {
  div {
    display: inline-block;
  }

  .el-select {
    width: 60%;
  }
}

.body-textarea {
  min-height: 180px;
  max-height: 800px;
}

.media-preview {
  position: relative;
  display: inline-block;
  padding: math.div($spacing-unit, 2) $spacing-unit;
  border: 1px solid $border-color;
  border-radius: $round;

  .media-name {
    padding-right: $spacing-unit * 3;
  }

  .mdi {
    position: absolute;
    top: math.div($spacing-unit, 2);
    right: math.div($spacing-unit, 2);
    cursor: pointer;
  }
}

.direct-media {
  max-width: 100%;
  max-height: $spacing-unit * 32;
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment'
import { mapActions, mapState } from 'pinia'
import twitterText from 'twitter-text'
import { defineComponent, PropType } from 'vue'
import { required } from 'vuelidate/lib/validators'

import Editable from '@/client/components/_atoms/editable'
import Message from '@/client/components/_atoms/Message.vue'
import MessageConvert from '@/client/components/_atoms/message_convert'
import api from '@/client/core/api'
import TwitterUpload from '@/client/core/twitter_upload'
import Util from '@/client/core/util'
import { formatNumber } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'
import { useTwitterApplicantStore } from '@/client/store/useTwitterApplicantStore'
import { useTwitterDirectMessageDialogStore } from '@/client/store/useTwitterDirectMessageDialogStore'
import { useTwitterSerialCodeDialogStore } from '@/client/store/useTwitterSerialCodeDialogStore'
import { actionDatetimeSchema } from '@/typings/api/twitter_message_queues.schema'

export default defineComponent({
  components: {
    Editable,
    MessageConvert,
    Message
  },
  props: {
    messageQueueId: Number,
    messageQueues: Array as PropType<readonly unknown[]>,
    messageTemplates: Array,
    successMessageQueueEdit: Function,
    isChangeWithoutSubmit: Boolean,
    isCopy: Boolean
  },
  data() {
    return {
      types: [
        {
          label: '当選通知',
          value: 0,
          text: ' 一度も当選メッセージを配信していない未回答の当選者全員'
        },
        {
          label: 'リマインド',
          value: 2,
          text: '当選通知を配信したことのある、未回答の当選者全員'
        },
        {
          label: 'シリアルコード未使用のリマインド',
          value: 3,
          text: 'シリアルコードが未使用の当選者全員(使用済みシリアルコードをシリアルコードの管理にインポートできます。)'
        }
      ],
      type: null,
      sentAccountFilterType: 0,
      answeredAccountFilterType: 1,
      body: '',
      sendType: 'DM',
      sendLimitPerDay: 0,
      startDate: null,
      startDateOption: {
        disabledDate(time: any) {
          return moment(time.getTime()).format('YYYY-MM-DD') < moment().tz('Asia/Tokyo').format('YYYY-MM-DD')
        }
      },
      startTime: null,
      startTimeOption: {
        start: '00:00',
        step: '00:30',
        end: '23:30'
      },
      endTime: null,
      endTimeOption: {
        start: '00:00',
        step: '00:30',
        end: '23:30'
      },
      isDisabledInput: false,
      isSubmit: false,
      oldTemplate: '',
      template: '',
      media: null,
      isLoadMedia: false,
      uploadTimer: null,
      remainMonthlyDmCount: 0,
      remainMonthlyDmCountDefault: 0,
      maxMonthlyDmCount: 0,
      sendCount: 0,
      isSendCountLoading: false,
      rawData: {},
      isFirstEdit: true
    }
  },
  beforeDestroy() {
    if (this.uploadTimer) {
      clearInterval(this.uploadTimer)
    }
  },
  created() {
    this.reset()

    if (this.messageQueueId === 0) {
      this.rawData = this.getMessageData()
      return
    }

    let current = null

    this.messageQueues.forEach(messageQueue => {
      if (messageQueue.id === this.messageQueueId) {
        current = Object.assign({}, messageQueue)
      }
    })

    if (current === null) {
      this.rawData = this.getMessageData()
      return
    }

    const { status, type, sendType, body, actionDatetime, media, endTime, sendLimitPerDay } = current

    this.isDisabledInput = this.isEdit && ['sent', 'sending', 'paused'].includes(status)
    this.type = type
    this.sendType = sendType
    this.body = body
    this.sendLimitPerDay = sendLimitPerDay
    this.startDate = moment(actionDatetime).format('YYYY-MM-DD')
    this.startTime = moment(actionDatetime).format('HH:mm')
    this.endTime = endTime ? moment(endTime, 'HH:mm:ss').format('HH:mm') : null

    this.media = media ? Object.assign({}, media) : null

    if (!this.isDisabledInput) {
      this.onChangeType()
    }

    if (this.type !== null) {
      this.getSendCount()
    }

    this.rawData = this.getMessageData()
    this.$nextTick(() => {
      this.$emit('update:isChangeWithoutSubmit', false)
    })

    if (this.isCopy) {
      this.startDate = null
      this.startTime = null
      this.endTime = null
    }

    if (!this.queueId) {
      this.isFirstEdit = true
    }
  },

  watch: {
    isFormChanged(value: boolean) {
      this.$emit('update:isChangeWithoutSubmit', value)
    },

    startDate(value: string) {
      if (value) {
        this.updateRemainMonthlyDmCount()

        if (!this.isFirstEdit) {
          const params: { accountId: number; actionDatetime: string; queueId?: number; campaignType?: string } = {
            accountId: this.campaign.account.id,
            actionDatetime: this.messageData.actionDatetime
          }

          if (this.isEdit) {
            params.queueId = this.messageQueueId
            params.campaignType = 'CP'
          }

          this.fetchCheckExistQueues(params)
        }
      }
    },

    startTime(value: string) {
      if (value && !this.isFirstEdit) {
        const params: { accountId: number; actionDatetime: string; queueId?: number; campaignType?: string } = {
          accountId: this.campaign.account.id,
          actionDatetime: this.messageData.actionDatetime
        }

        if (this.isEdit) {
          params.queueId = this.messageQueueId
          params.campaignType = 'CP'
        }

        this.fetchCheckExistQueues(params)
      }
    },

    isStartDateTimeInEdit(value: boolean) {
      if (value && this.isFirstEdit) {
        this.isFirstEdit = false

        const params: { accountId: number; actionDatetime: string; queueId?: number; campaignType?: string } = {
          accountId: this.campaign.account.id,
          actionDatetime: this.messageData.actionDatetime
        }

        if (this.isEdit) {
          params.queueId = this.messageQueueId
          params.campaignType = 'CP'
        }

        this.fetchCheckExistQueues(params)
      }
    },

    maxSendLimitPerDay(value: number) {
      if (value < this.sendLimitPerDay) this.sendLimitPerDay = 0
    }
  },

  computed: {
    ...mapState(useTwitterDirectMessageDialogStore, {
      campaignId: state => state.campaignId,
      prizeId: state => state.prizeId,
      isExistQueue: state => state.isExistQueue
    }),
    ...mapState(useTwitterSerialCodeDialogStore, {
      serialCode: state => state.serialCode
    }),
    ...mapState(useTwitterApplicantStore, {
      verifiedType: state => state.campaign.account.verifiedType,
      isVerifiedAccount: state => state.campaign.account.isVerified,
      campaign: state => state.campaign
    }),
    /**
     * ハイライト定義データ
     */
    highlights() {
      return [{ type: 'info', keywords: ['_account_name_', '_screen_name_', '_account_id_', '_serial_code_'] }]
    },

    /**
     * ヘルプテキスト取得
     */
    typeText() {
      let text = null
      this.types.forEach(type => {
        if (type.value === this.type) text = type.text
      })
      return text
    },

    /**
     * メッセージ内容の文字数取得
     */
    bodyLength() {
      if (!this.body) {
        return 0
      }

      return twitterText.parseTweet(this.body).weightedLength
    },

    hasSerialCodeInMessageBody() {
      return /_serial_code_/.test(this.body)
    },

    /**
     * 新規作成か編集かのチェック
     */
    isEdit() {
      return this.messageQueueId > 0 && !this.isCopy
    },

    isStartDateTimeInEdit() {
      return this.startDate && this.startTime
    },

    disabledSubmit() {
      if (
        !this.startDate ||
        !this.startTime ||
        this.body === '' ||
        this.type === null ||
        this.bodyLength > this.maxLength ||
        this.body.trim().length === 0 ||
        this.isLoadMedia
      ) {
        return true
      }

      if (this.isDateInput || this.isStartTimeInput || this.isEndTimeInput || this.isTimeOver || this.isDatetimeOver) {
        return true
      }

      return false
    },

    isImage() {
      const reg = /[.](jpeg|png|gif|pjpeg|jpg)$/i
      return reg.test(this.media.mediaUrl)
    },

    isTypeSelected() {
      return this.type !== null
    },

    isSendCountEmpty() {
      return this.sendCount === 0
    },

    isLimitSendCount() {
      return this.remainMonthlyDmCount !== null
    },

    isRemainEmpty() {
      return this.remainMonthlyDmCount === 0
    },

    isSendCountOver() {
      if (this.remainMonthlyDmCount === null) return false
      return this.sendCount > this.remainMonthlyDmCount
    },

    isDateInput() {
      if (!this.startDate) {
        return true
      }

      return false
    },

    isDatetimeOver() {
      if (!this.startDate || !this.startTime) {
        return false
      }

      const parseResult = actionDatetimeSchema.safeParse(this.getActionDatetime())
      return !parseResult.success
    },

    isStartTimeInput() {
      if (!this.startTime) {
        return true
      }

      return false
    },

    isEndTimeInput() {
      if (this.startTime && !this.endTime) {
        return true
      }

      return false
    },

    isTimeOver() {
      if (this.startTime && this.endTime && this.startTime >= this.endTime) {
        return true
      }

      return false
    },

    messageData() {
      return this.getMessageData()
    },

    isFormChanged() {
      return JSON.stringify(this.messageData) !== JSON.stringify(this.rawData)
    },

    maxSendLimitPerDay() {
      if (this.startTime && this.endTime) {
        const startTime = moment(this.startTime, 'HH:mm')
        const endTime = moment(this.endTime, 'HH:mm')

        const differenceInMinutes = endTime.diff(startTime, 'minutes')
        // 30分と比較して
        if (differenceInMinutes <= 30) {
          return 20
        }

        // 1時間と比較
        if (differenceInMinutes <= 60) {
          return 40
        }

        // 1.5時間と比較して
        if (differenceInMinutes <= 90) {
          return 60
        }

        // 2時間と比較してください
        if (differenceInMinutes <= 120) {
          return 80
        }
      }

      return 100
    },

    isUnlimitedOrLimit100() {
      return [0, 100].includes(this.sendLimitPerDay)
    },

    isLimitOneHourToTwoHoursMessage() {
      if ([20, 40, 60, 80].includes(this.maxSendLimitPerDay)) {
        return this.sendLimitPerDay === this.maxSendLimitPerDay
      }

      return false
    },

    limitOneHourToTwoHoursMessage() {
      let time = ''

      if (this.maxSendLimitPerDay === 20) {
        time = '30分間'
      }

      if (this.maxSendLimitPerDay === 40) {
        time = '1時間'
      }

      if (this.maxSendLimitPerDay === 60) {
        time = '1時間半'
      }

      if (this.maxSendLimitPerDay === 80) {
        time = '2時間'
      }

      return `リスク回避のため、ATELUでは${time}で最大${this.maxSendLimitPerDay}件のペースで送信する制限を設けてます。`
    }
  },
  methods: {
    formatNumber,

    ...mapActions(useTwitterDirectMessageDialogStore, [
      'fetchQueueList',
      'setQueueListIsShowDetail',
      'fetchCheckExistQueues'
    ]),

    /**
     * 値のリセット
     */
    reset() {
      this.type = null
      this.sentAccountFilterType = 0
      this.answeredAccountFilterType = 1
      this.body = ''
      this.startDate = null
      this.startTime = null
      this.endTime = null
      this.sendLimitPerDay = 0
      this.isDisabledInput = false
      this.isSubmit = false
      this.$emit('update:isChangeWithoutSubmit', false)
      this.$v.body.$reset()
    },

    /**
     * 送信完了イベント
     */
    onSubmitSuccess() {
      this.reset()
      this.fetchQueueList()
      this.setQueueListIsShowDetail(false)
      this.successMessageQueueEdit()
    },

    /**
     * 種別の変更
     */
    onChangeType(value: string) {
      if (value === '種別') TrackingService.sendEvent('select:当選メッセージの管理|メッセージの新規作成|種別')

      this.getSendCount()

      switch (this.type) {
        case 0:
          this.sentAccountFilterType = 0
          this.answeredAccountFilterType = 1
          break
        case 1:
          this.sentAccountFilterType = 1
          this.answeredAccountFilterType = 1
          break
        case 2:
          this.sentAccountFilterType = 2
          this.answeredAccountFilterType = 1
          break
      }
    },

    /**
     * @param {number} templateId
     */
    onChangeTemplate(templateId: number) {
      TrackingService.sendEvent('select:当選メッセージの管理|メッセージの新規作成|テンプレート')

      const currentTemplate = this.messageTemplates.find(template => template.id === templateId)
      const body = currentTemplate.body

      if (!this.body) {
        this.body = body
        this.oldTemplate = templateId
        return
      }

      const confirmChange = confirm('メッセージがすでに入力されています。テンプレートの内容に置き換えてよろしいですか?')
      if (!confirmChange) {
        this.template = this.oldTemplate
        return
      }
      this.oldTemplate = templateId
      this.body = body
    },

    /**
     * 配信対象数と残り配信可能数の取得処理
     * @returns {void}
     */
    async getSendCount() {
      this.sendCount = 0
      this.remainMonthlyDmCount = 0
      this.maxMonthlyDmCount = 0

      const params = {
        type: this.type,
        campaignId: this.campaignId,
        prizeId: this.prizeId
      }

      this.isSendCountLoading = true

      const result = await api.get(`/twitter_message_queues/send_counts`, { params })

      if (!result || !result.data) {
        this.isSendCountLoading = false
        return
      }

      const { sendCount, remainMonthlyDmCount, maxMonthlyDmCount } = result.data

      this.sendCount = sendCount
      this.remainMonthlyDmCount = remainMonthlyDmCount
      this.remainMonthlyDmCountDefault = remainMonthlyDmCount
      this.maxMonthlyDmCount = maxMonthlyDmCount
      this.updateRemainMonthlyDmCount()
      this.isSendCountLoading = false
    },

    /**
     * 残り配信可能数を更新
     */
    updateRemainMonthlyDmCount() {
      if (this.maxMonthlyDmCount === 0) return

      const today = moment()
      const isAfter = moment(this.startDate, 'YYYY-MM').isAfter(today, 'month')

      this.remainMonthlyDmCount = isAfter ? this.maxMonthlyDmCount : this.remainMonthlyDmCountDefault
    },

    /**
     * メッセージ配信開始日時の取得
     */
    getActionDatetime() {
      return moment.tz(`${this.startDate} ${this.startTime}`, 'YYYY-MM-DD HH:mm', 'Asia/Tokyo').format()
    },

    /**
     * 下書き保存（既存）
     */
    saveDraft() {
      if (this.isSubmit) return

      this.updateQueue({ ...this.messageData, status: 'draft' })
    },

    /**
     * スケジュール保存（既存）
     */
    saveScheduled() {
      if (this.isSubmit) return

      this.updateQueue({ ...this.messageData, status: 'scheduled' })
    },

    /**
     * 下書き保存（新規）
     */
    createDraft() {
      TrackingService.sendEvent('click:当選メッセージの管理|メッセージの新規作成|下書き保存')

      if (this.isSubmit) return

      this.createQueue({ ...this.messageData, status: 'draft' })
    },

    /**
     * スケジュール保存（新規）
     */
    createScheduled() {
      TrackingService.sendEvent('click:当選メッセージの管理|メッセージの新規作成|新規作成')

      if (this.isSubmit) return

      this.createQueue({ ...this.messageData, status: 'scheduled' })
    },

    /**
     * エラーを表示
     * @param {string} title
     * @param {string} message
     */
    showError(title: string, message: string) {
      this.$notify({
        title,
        message,
        customClass: 'danger',
        dangerouslyUseHTMLString: true,
        duration: 5000
      })
    },

    /**
     * ファイルのメンションを変更
     */
    async handleFileChange(e) {
      TrackingService.sendEvent('click:当選メッセージの管理|メッセージの新規作成|新規作成')

      if (!e.target.files || !e.target.files[0]) {
        return
      }

      const file = e.target.files[0]
      this.$refs.mediaInput.value = null

      const validFormat = ['video/mp4', 'image/jpeg', 'image/png', 'image/gif', 'image/pjpeg', 'image/gif']

      // メディアをチェック
      const checkValidMedia = await TwitterUpload.checkValidMedia(file, validFormat)

      if (checkValidMedia.error) {
        const error = checkValidMedia.error

        let title = ''
        let message = ''

        switch (error) {
          case 'INVALID_MEDIA':
            title = 'Please upload valid format!'
            message = validFormat.join(', ')
            break
          case 'MAX_SIZE_VIDEO':
            title = '25MB以上のビデオを利用することはできません。 サイズを調整してからアップロードしてください。'
            break
          case 'MAX_SIZE_IMAGE':
            title = '5MB以上の画像を利用することはできません。サイズを調整してからアップロードしてください。'
            break
          case 'INVALID_DIMENSION':
            title = '画像・動画アップロードに失敗しました。'
            message =
              '詳しくは<a target="_blank" href="https://help-atelu.comnico.jp/available-image-and-video">こちら</a>をご確認ください。'
            break
        }

        this.showError(title, message)

        return
      }

      this.isLoadMedia = true

      const formData = new FormData()
      formData.append('file', file)

      if (file.type.includes('video')) {
        const mediaCheck = await TwitterUpload.checkMedia(formData)

        if (!mediaCheck) {
          const title = '画像・動画アップロードに失敗しました。'
          const message =
            '詳しくは<a target="_blank" href="https://help-atelu.comnico.jp/available-image-and-video">こちら</a>をご確認ください。'

          this.showError(title, message)
          this.isLoadMedia = false

          return
        }
      }

      formData.append('accountId', this.campaign.account.id)

      formData.append('forDM', 'true')

      const result = await TwitterUpload.uploadMedia(formData)

      // アップロードプログレスを取得
      const progressResult = await this.getUploadProgress(result.data.filename)

      if (progressResult) {
        const media = {
          mediaOriginName: file.name,
          mediaUrl: progressResult.mediaUrl,
          twMediaId: progressResult.mediaId,
          expiresAfterSecs: progressResult.expiresAfterSecs
        }

        this.media = this.media ? Object.assign(this.media, media) : media
      }

      this.isLoadMedia = false
    },

    /**
     * アップロードプログレスを取得
     * @param {string} filename
     */
    getUploadProgress(filename: string) {
      const startUploadTime = moment()
      return new Promise(resolve => {
        this.uploadTimer = setInterval(async () => {
          const duration = moment.duration(moment().diff(startUploadTime))
          if (duration.asSeconds() > 300) {
            const title = '画像・動画アップロードに失敗しました。'
            const message = '恐れ入りますが、時間をおいて再度お試しください。'

            this.showError(title, message)

            clearInterval(this.uploadTimer)
            resolve(null)
          }

          const progress = await api.get(`/twitter_uploads/progresses?filename=${filename}`)
          if (progress.data) {
            clearInterval(this.uploadTimer)
            resolve(progress.data)
          }

          if (progress.error) {
            if (progress.error.statusCode === 400) {
              const title = '画像・動画アップロードに失敗しました。'
              const message =
                '詳しくは<a target="_blank" href="https://help-atelu.comnico.jp/available-image-and-video">こちら</a>をご確認ください。'

              this.showError(title, message)
            } else {
              const title = '画像・動画アップロードに失敗しました。'
              const message = '恐れ入りますが、時間をおいて再度お試しください。'

              this.showError(title, message)
            }

            clearInterval(this.uploadTimer)
            resolve(null)
          }
        }, 5000)
      })
    },

    /**
     * メンションのメディアファイル削除
     */
    removeMedia() {
      this.media = null
    },

    /**
     * メッセージキューの更新
     * @param {Object} params 配信データ
     */
    async updateQueue(params: any) {
      this.isSubmit = true

      const response = await api.put(`/twitter_message_queues/${this.messageQueueId}`, params)

      setTimeout(() => {
        this.isSubmit = false
      }, 2000)

      if (response.data) {
        this.$notify({
          title: 'メッセージを保存しました。',
          customClass: 'success',
          duration: 5000
        })
        this.onSubmitSuccess()
        return
      }

      if (response.error && response.error.type === 'NOT_EXISTS') {
        this.$notify({
          title: '対象のメッセージが見つかりません。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })
        return
      }

      if (response.error && response.error.type === 'MESSAGE_QUEUE_COUNT_OVER') {
        this.$notify({
          title: '同じ時刻にスケジュールされている一括配信があります。',
          message: '30分以上間隔を空けるようにしてください。',
          customClass: 'danger',
          duration: 5000
        })
        return
      }

      this.$notify({
        title: 'メッセージの保存に失敗しました。',
        message: '恐れ入りますが、時間をおいて再度お試しください。',
        customClass: 'danger',
        duration: 5000
      })
    },

    /**
     * メッセージキューの新規作成
     * @param {Object} params 配信データ
     */
    async createQueue(params: any) {
      this.isSubmit = true

      const response = await api.post(`/twitter_message_queues`, params)

      setTimeout(() => {
        this.isSubmit = false
      }, 2000)

      if (response.data) {
        this.$notify({
          title: this.isCopy ? 'メッセージ配信スケジュールを複製しました。' : 'メッセージを作成しました。',
          customClass: 'success',
          duration: 5000
        })
        this.onSubmitSuccess()
        return
      }

      if (response.error && response.error.type === 'MESSAGE_QUEUE_COUNT_OVER') {
        this.$notify({
          title: '同じ時刻にスケジュールされている一括配信があります。',
          message: '30分以上間隔を空けるようにしてください。',
          customClass: 'danger',
          duration: 5000
        })
        return
      }

      this.$notify({
        title: this.isCopy ? 'メッセージ配信スケジュールの複製に失敗しました。' : 'メッセージの作成に失敗しました。',
        message: '恐れ入りますが、時間をおいて再度お試しください。',
        customClass: 'danger',
        duration: 5000
      })
    },

    copyToClipboard(variable: string) {
      this.$message({
        message: `${variable}をクリップボードにコピーしました。`,
        type: 'success'
      })

      Util.copyToClipboard(variable)
    },

    /**
     * 戻る
     */
    back() {
      TrackingService.sendEvent('click:当選メッセージの管理|メッセージの新規作成|戻る')

      if (!this.isChangeWithoutSubmit) {
        return this.successMessageQueueEdit()
      }

      const confirm = window.confirm('編集内容が保存されていません。ダイアログを閉じてよろしいですか?')

      if (!confirm) {
        return
      }

      this.$emit('update:isChangeWithoutSubmit', false)
      return this.successMessageQueueEdit()
    },

    /**
     * メッセージのデータを取得
     */
    getMessageData() {
      return {
        twCampaignPrizeId: this.prizeId,
        campaignId: this.campaignId,
        type: this.type,
        sendType: this.sendType,
        body: this.body,
        actionDatetime: this.getActionDatetime(),
        endTime: this.endTime,
        sendLimitPerDay: this.sendLimitPerDay,
        sentAccountFilterType: this.sentAccountFilterType,
        answeredAccountFilterType: this.answeredAccountFilterType,
        media: this.media
      }
    },

    clickLink() {
      TrackingService.sendEvent('click:当選メッセージの管理|メッセージの新規作成|テンプレート管理')
    },

    onChangeMessage() {
      TrackingService.sendEvent('input:当選メッセージの管理|メッセージの新規作成|メッセージ内容')
    },

    onChangeStartDate() {
      TrackingService.sendEvent('select:当選メッセージの管理|メッセージの新規作成|メッセージ配信開始日')
    },

    onChangeStartTime() {
      TrackingService.sendEvent('select:当選メッセージの管理|メッセージの新規作成|開始時間')
    },

    onChangeEndTime() {
      TrackingService.sendEvent('select:当選メッセージの管理|メッセージの新規作成|終了時間')
    }
  },

  validations: {
    body: {
      required
    }
  }
})
</script>
